// extracted by mini-css-extract-plugin
export var bodyRow = "_hv-d";
export var cardColumns = "_hv-e";
export var ellipsesOverflow = "_hv-2";
export var flatBottomCorners = "_hv-3";
export var flatTopCorners = "_hv-4";
export var headerActionsDropdown = "_hv-f";
export var headerBottomRow = "_hv-c";
export var headerTopRow = "_hv-b";
export var orderDetailsWrapper = "_hv-0";
export var orderInfoContainer = "_hv-1";
export var productDetails = "_hv-9";
export var productImage = "_hv-5";
export var responsiveTable = "_hv-8";
export var shipmentContainer = "_hv-a";
export var tableBottomLeft = "_hv-6";
export var tableBottomRight = "_hv-7";
export var trackingLink = "_hv-g";